import React from "react";
import "./Competitions.scss";
import Button from "../../reusable/Button/Button";
import { ReactComponent as ArrowRightIcon } from "../../../../../assets/icons/svg/arrow-right.svg";
import { useHistory } from "react-router-dom";

export default function Competitions(props) {
  const history = useHistory();
  const coaches = [
    { key: 1, name: "Narcis Badic" },
    { key: 2, name: "Alin Lungu" },
    { key: 3, name: "Dan Savin" },
  ];

  return (
    <div
      className="competition-element-container-3"
      style={{ borderRadius: 30, borderColor: "white" }}
    >
      <div
        className="competition-name"
        style={{ color: props.config_options.groups_name_color }}
      >
        {props.competition.competition_name}
      </div>
      <div
        className="competition-group notranslate"
        style={{ color: props.config_options.groups_name_color }}
      >
        <span style={{ color: "#01b1e4", paddingRight: 5 }}>Grupa: </span>
        {props.competition.category}
      </div>
      <div
        className="competition-coach"
        style={{ color: props.config_options.groups_coach_color }}
      >
        <div>
          <div className="coach" style={{ color: "#01b1e4" }}>
            Antrenori:
          </div>
          {coaches.map((item) => {
            return (
              <div className="coach-name notranslate" key={item.key}>
                {item.name}
              </div>
            );
          })}
        </div>
      </div>
      <div className="discover-more-button">
        <button
          className="arrow-button"
          onClick={() =>
            history.push(
              `/competitions/${props.competition.competition_name
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/[^a-zA-Z0-9 \-]/g, "")
                .replaceAll(" ", "-")}-${props.competition.id_competition}`
            )
          }
          theme={props.config_options.id_theme}
          color={props.config_options.buttons_text_color}
          backgroundColor={props.config_options.buttons_color}
        >
          Află mai multe{" "}
          {/* <ArrowRightIcon
            fill={props.config_options.buttons_text_color}
            className="discover-more-button-icon"
          /> */}
        </button>
      </div>
    </div>
  );
}
